import { motion } from "framer-motion";
import { ShieldCheck, Leaf, Clock3, Banknote } from "lucide-react";

const items = [
  { icon: ShieldCheck, title: "Trained Professionals", text: "Background-verified teams with hands-on training." },
  { icon: Leaf, title: "Eco-friendly Products", text: "Non-toxic, child & pet safe cleaning solutions." },
  { icon: Clock3, title: "On-time, Always", text: "We respect your schedule — arrivals within the window." },
  { icon: Banknote, title: "Transparent Pricing", text: "Get a clear quote upfront. No surprises, ever." },
];

export default function WhyUs() {
  return (
    <section id="why" className="py-20 md:py-28 bg-slate-50 relative overflow-hidden" data-testid="why-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="max-w-2xl">
          <span className="text-xs font-bold uppercase tracking-[0.15em] text-sky-600">Why Shine Express</span>
          <h2 className="font-display mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900">
            A cleaning service you can actually rely on.
          </h2>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {items.map((it, idx) => {
            const Icon = it.icon;
            return (
              <motion.div
                key={it.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.45, delay: idx * 0.08 }}
                className="relative rounded-2xl bg-white border border-slate-100 p-6 shadow-[0_8px_30px_rgba(0,0,0,0.04)]"
                data-testid={`why-item-${idx}`}
              >
                <span className="absolute -top-4 right-6 font-display text-5xl font-extrabold text-sky-100 select-none">
                  0{idx + 1}
                </span>
                <div className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-sky-50 text-sky-600">
                  <Icon className="h-5 w-5" />
                </div>
                <h3 className="font-display mt-4 text-lg font-semibold text-slate-900">{it.title}</h3>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">{it.text}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
